import { useState } from "react";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { FormStepper } from "../../../common";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { pathConstants } from "../../../../routes/pathContants";

export const StorefrontFormCover = () => {
  const { menuId } = useParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [steps] = useState([
    {
      title: "Storefront Details",
      id: 0,
      route: pathConstants.INVENTORY_MENU_CREATE_EDIT({ menuId }),
    },
    {
      title: "Customization",
      id: 1,
      route: pathConstants.INVENTORY_MENU_DETAILS_CUSTOMIZATION_CHECKOUT({
        menuId,
      }),
    },
    {
      title: "Shipping Setup",
      id: 2,
      route: pathConstants.INVENTORY_MENU_CREATE_SHIPPING({ menuId }),
    },
  ]);

  const currentStep = pathname?.includes("customization")
    ? 1
    : pathname?.includes("shipping")
      ? 2
      : 0;

  return (
    <div
      className={`${globalStyles.cardWithBackground} white`}
      style={{ gap: "35px" }}
    >
      <FormStepper
        steps={steps}
        currentStep={currentStep}
        navigateToStep={(step_id) => {
          const route = steps?.find((item) => item?.id === step_id)?.route;
          navigate(route);
        }}
      />

      <Outlet />
    </div>
  );
};
